import { cn } from '@lib/cn'
import React, { FC, HTMLAttributes } from 'react'

type As = 'div' | 'p' | 'span' | 'label' | 'li'
type TextProps = HTMLAttributes<HTMLElement> & {
  variant: 'regular' | 'small-description' | 'description'
  as?: As
}

export const Text: FC<TextProps> = ({
  variant = 'regular',
  children,
  className,
  as: Component = 'div',
  ...rest
}) => {
  return (
    <Component
      className={cn(
        'whitespace-pre-line font-rolex font-light text-rolexShade-900',
        '[&_a]:transition-colors [&_a]:duration-150 [&_a]:hover:text-rolexPrimary/80 [&_a]:focus:text-rolexPrimary/80',
        variant === 'regular' && 'leading-1 text-[1rem]',
        variant === 'description' && 'text-[0.75rem] md:text-[14px]',
        variant === 'small-description' && 'text-[11px] md:text-[0.75rem]',
        className,
      )}
      {...rest}
    >
      {children}
    </Component>
  )
}
